import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShowImageDialogComponent } from './show-image-dialog.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CustomMaterialModule } from '@sk/custom-material';

@NgModule({
  declarations: [ShowImageDialogComponent],
  imports: [
    CommonModule,
    CustomMaterialModule,
    FlexLayoutModule,
  ],
})
export class ShowImageDialogModule {
}
